export const GET_PREMIUM_PLAN="GET_PREMIUM_PLAN"
export const ADD_PREMIUM_PLAN="ADD_PREMIUM_PLAN"
export const UPDATE_PREMIUM_PLAN="UPDATE_PREMIUM_PLAN"
export const ACTIVE_PREMIUM_PLAN="ACTIVE_PREMIUM_PLAN"
export const DELETE_PREMIUM_PLAN="DELETE_PREMIUM_PLAN"



